import Vue from 'vue';
import Router from 'vue-router';

import auth from '@/auth';
import config from '@/config';
import store from '@/store';
import { ROUTE_CALENDAR, ROUTE_LOGIN } from '@/router/names';
import { FETCH_COACH } from '@/store/coach/types';

import Login from './login';
import Calendar from './calendar';
import Coach from './coach';
import Course from './course';
import Trainer from './trainer';
import Invite from './invite';
import Wechat from './wechat';
import Share from './share';
import Guide from './guide';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: {
                name: ROUTE_CALENDAR,
            },
        },
        ...Login,
        ...Calendar,
        ...Coach,
        ...Course,
        ...Trainer,
        ...Invite,
        ...Wechat,
        ...Share,
        ...Guide,
    ],
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || config.title;
    if (to.matched.some(record => record.meta.auth)) {
        if (!auth.loggedIn()) {
            next({
                name: ROUTE_LOGIN,
                query: { redirect: to.fullPath },
            });
        } else {
            if (!store.state.coach.coach) {
                store.dispatch(`coach/${FETCH_COACH}`);
            }
            next();
        }
    } else {
        next();
    }
});

router.afterEach((to) => {
    if (!to.meta.bridge) {
        const url = `${location.origin}${to.fullPath}`;
        Vue.wechat.config(url);
    }
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js